/* eslint-disable */
import qFetch from '@/utils/qFetch'

// 获取抽奖转盘信息
export function fetchDrawInfo(prizeId) {
  const url = '/draw/showdrawpage/v2'
  const ajaxData = {
    promotionCode: prizeId
  }
  return qFetch({
    url: '/tjbnb/app/common/nologin',
    data: ajaxData,
    extraParam: {
      u: url
    },
  }).then((res) => {
    return Promise.resolve(res)
  })
}

// 获取他人中奖信息
export function fetchOtherDrawList(prizeId) {
  const url = '/draw/getotherprizelist'
  const ajaxData = {
    promotionCode: prizeId
  }
  return qFetch({
    url: '/tjbnb/app/common/nologin',
    data: ajaxData,
    extraParam: {
      u: url
    },
  }).then((res) => {
    return Promise.resolve(res)
  })
}

// 获取我的中奖信息
export function fetchMyDrawList(prizeId) {
  const url = '/draw/mygroupprize'
  const ajaxData = {
    promotionCode: prizeId
  }
  return qFetch({
    url: '/tjbnb/app/common/login',
    data: ajaxData,
    extraParam: {
      u: url
    },
  }).then((res) => {
    return Promise.resolve(res)
  })
}

// 开始抽奖
export function drawStart(prizeId) {
  const url = '/draw/startdraw/v2'
  const ajaxData = {
    promotionCode: prizeId
  }
  return qFetch({
    url: '/tjbnb/app/common/login',
    data: ajaxData,
    extraParam: {
      u: url
    },
  }).then((res) => {
    return Promise.resolve(res)
  })
}

// 保存邮寄地址
export function saveAddress(addressInfo) {
  const url = '/draw/savemailaddress'
  return qFetch({
    url: '/tjbnb/app/common/login',
    data: addressInfo,
    extraParam: {
      u: url
    },
  }).then((res) => {
    return Promise.resolve(res)
  })
}
